import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; } }

export default function BeritaList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/berita?limit=50").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Terkini</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Berita SILAING</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Informasi terbaru dari Dinas Kelautan dan Perikanan Provinsi Jawa Barat.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((b) => (
          <Link key={b.id} to={`/informasi/berita/${b.slug}`} className="lift-card bg-white rounded-2xl overflow-hidden shadow-md border border-slate-100 flex flex-col">
            <div className="aspect-[16/10] overflow-hidden"><img src={b.cover} alt={b.judul} className="w-full h-full object-cover" /></div>
            <div className="p-5 flex-1 flex flex-col">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-[#E1F5FF] text-[#005F8E]">{b.kategori}</span>
                <span className="text-xs text-slate-500">{fmtDate(b.tanggal)}</span>
              </div>
              <h3 className="font-heading font-bold text-[#003A5C] leading-snug mb-2 line-clamp-2">{b.judul}</h3>
              <p className="text-sm text-slate-600 line-clamp-2 mb-4">{b.excerpt}</p>
              <div className="mt-auto inline-flex items-center gap-1 text-[#00B4D8] font-semibold text-sm">Baca <ArrowRight className="w-3.5 h-3.5" /></div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
